module.exports = __webpack_public_path__ + "static/media/call-to-action-dark-blue-bokeh@2x.91f69051.jpg";